// extracted by mini-css-extract-plugin
export default {"PharmacyFormContainer":"rTHWoP1Z"};